/* ---------------------------------------------------------------------
   Product photo zoom (V12). Works on the product page gallery only
   (.pdp-gallery[data-zoom-gallery] in sections/main-product.liquid).
   Styles: assets/pdp-zoom.css.

   1. Tap a photo (phones) or the large photo (tablets and computers):
      a full-screen viewer opens on that photo, the way Noon does it.
      Swipe or use the arrows to move between photos, the counter shows
      «2 من 4» / «2 of 4», and the thumbnails jump to a photo.
      Pinch or double-tap to zoom (computers: click or the mouse wheel),
      drag to move around a zoomed photo, pull down to close (phones).
      The phone's back button closes the viewer and stays on the page.
   2. Pinch a photo in the swipe strip (phones): the photo grows in place
      over the page and springs back when the fingers lift, the way
      Instagram does it.

   Right-to-left pages move the other way round: the next photo sits on
   the left, as in the swipe strip on the page.
   On tablets and computers a click on a small photo still makes it the
   large photo (the small script next to the gallery does that); only
   the large photo opens the viewer.
   --------------------------------------------------------------------- */
(function () {
  'use strict';

  var gallery = document.querySelector('.pdp-gallery[data-zoom-gallery]');
  if (!gallery || gallery.getAttribute('data-zoom-ready')) return;
  var pics = [].slice.call(gallery.querySelectorAll('img'));
  if (!pics.length) return;
  gallery.setAttribute('data-zoom-ready', '1');

  var html = document.documentElement;
  var rtl = (html.getAttribute('dir') || '').toLowerCase() === 'rtl';
  var wide = window.matchMedia('(min-width: 750px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ds = gallery.dataset;
  var T = {
    title: ds.zTitle || 'Product photos',
    close: ds.zClose || 'Close',
    of: ds.zOf || 'of',
    prev: ds.zPrev || 'Previous photo',
    next: ds.zNext || 'Next photo',
    photo: ds.zPhoto || 'Photo'
  };
  var MAX = 4;       // deepest zoom in the viewer
  var STEP = 2.5;    // zoom for a double-tap or a click
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  var CHEV = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m15 18-6-6 6-6"/></svg>';

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function dist(a, b) { var x = a.x - b.x, y = a.y - b.y; return Math.sqrt(x * x + y * y); }
  function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
  function ms(n) { return calm.matches ? 0 : n; }
  function srcOf(img) { return img.currentSrc || img.getAttribute('src') || ''; }
  function make(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]);
    return e;
  }
  // Past a limit the photo still follows the finger, but only a little.
  function rubber(v, a, b) {
    if (v < a) return a - (a - v) * 0.35;
    if (v > b) return b + (v - b) * 0.35;
    return v;
  }

  /* ------------------------------------------------------------------
     1. Full-screen viewer, built on first open.
     ------------------------------------------------------------------ */
  var V = null;
  var slides = [];   // { box, img, ar, fw, fh, l, t, s, x, y, hi }
  var thumbs = [];
  var idx = 0, W = 0, H = 0;
  var isOpen = false, pushed = false, lastFocus = null, hideTimer = 0;

  function build() {
    V = {};
    V.root = make('div', 'bkz', { role: 'dialog', 'aria-modal': 'true', 'aria-label': T.title });
    V.root.hidden = true;
    V.bg = make('div', 'bkz-bg');
    V.top = make('div', 'bkz-top');
    V.close = make('button', 'bkz-close', { type: 'button', 'aria-label': T.close });
    V.close.innerHTML = CHEV;
    V.count = make('p', 'bkz-count', { 'aria-live': 'polite' });
    V.top.appendChild(V.close);
    V.top.appendChild(V.count);
    V.stage = make('div', 'bkz-stage');
    V.track = make('div', 'bkz-track');
    V.stage.appendChild(V.track);
    V.prev = make('button', 'bkz-arrow bkz-arrow--prev', { type: 'button', 'aria-label': T.prev });
    V.next = make('button', 'bkz-arrow bkz-arrow--next', { type: 'button', 'aria-label': T.next });
    V.prev.innerHTML = CHEV;
    V.next.innerHTML = CHEV;
    V.stage.appendChild(V.prev);
    V.stage.appendChild(V.next);
    V.strip = make('div', 'bkz-thumbs');

    pics.forEach(function (p, i) {
      var w = parseFloat(p.getAttribute('data-zw')) || 1200;
      var h = parseFloat(p.getAttribute('data-zh')) || 1200;
      var box = make('div', 'bkz-slide');
      var img = make('img', 'bkz-img', { alt: p.getAttribute('alt') || '', draggable: 'false', decoding: 'async' });
      img.src = srcOf(p);
      box.appendChild(img);
      V.track.appendChild(box);
      slides.push({ box: box, img: img, ar: w / h, fw: 0, fh: 0, l: 0, t: 0, s: 1, x: 0, y: 0, hi: false });

      var b = make('button', 'bkz-thumb', { type: 'button', 'aria-label': T.photo + ' ' + (i + 1) });
      var ti = make('img', '', { alt: '', loading: 'lazy', decoding: 'async' });
      ti.src = p.getAttribute('data-zoom-thumb') || srcOf(p);
      b.appendChild(ti);
      b.addEventListener('click', function () { go(i, ms(280)); });
      V.strip.appendChild(b);
      thumbs.push(b);
    });

    if (pics.length < 2) V.root.classList.add('is-single');
    V.root.appendChild(V.bg);
    V.root.appendChild(V.top);
    V.root.appendChild(V.stage);
    V.root.appendChild(V.strip);
    document.body.appendChild(V.root);

    V.close.addEventListener('click', requestClose);
    V.prev.addEventListener('click', function () { go(idx - 1, ms(280)); });
    V.next.addEventListener('click', function () { go(idx + 1, ms(280)); });
    V.stage.addEventListener('pointerdown', onDown);
    V.stage.addEventListener('pointermove', onMove);
    V.stage.addEventListener('pointerup', onUp);
    V.stage.addEventListener('pointercancel', onUp);
    V.stage.addEventListener('wheel', onWheel, { passive: false });
    // Older iPhones: keep Safari's own page zoom out of the viewer.
    V.root.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    V.root.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
  }

  function measure() {
    var r = V.stage.getBoundingClientRect();
    W = r.width;
    H = r.height;
    slides.forEach(fit);
  }

  // Size each photo to fit the stage whole (no cropping) and centre it.
  function fit(sl) {
    var fw = Math.min(W, H * sl.ar), fh = fw / sl.ar;
    sl.fw = fw; sl.fh = fh;
    sl.l = (W - fw) / 2; sl.t = (H - fh) / 2;
    var st = sl.img.style;
    st.width = fw + 'px'; st.height = fh + 'px';
    st.left = sl.l + 'px'; st.top = sl.t + 'px';
    sl.s = 1; sl.x = 0; sl.y = 0;
    paint(sl, 0);
  }

  function paint(sl, t) {
    var st = sl.img.style;
    st.transition = t ? 'transform ' + t + 'ms ' + EASE : 'none';
    st.transform = 'translate3d(' + sl.x + 'px,' + sl.y + 'px,0) scale(' + sl.s + ')';
    if (sl === slides[idx] && V) V.root.classList.toggle('is-zoomed', sl.s > 1.01);
  }

  // How far a photo at zoom s may move. A photo smaller than the stage
  // stays centred on that axis.
  function bounds(sl, s) {
    var w = sl.fw * s, h = sl.fh * s, b = {};
    if (w <= W) { b.x0 = b.x1 = (sl.fw - w) / 2; } else { b.x0 = W - w - sl.l; b.x1 = -sl.l; }
    if (h <= H) { b.y0 = b.y1 = (sl.fh - h) / 2; } else { b.y0 = H - h - sl.t; b.y1 = -sl.t; }
    return b;
  }

  // Zoom to s2 keeping the point (fx, fy) of the stage under the finger.
  function zoomAt(sl, s2, fx, fy) {
    var lx = (fx - sl.l - sl.x) / sl.s, ly = (fy - sl.t - sl.y) / sl.s;
    sl.s = s2;
    sl.x = fx - sl.l - s2 * lx;
    sl.y = fy - sl.t - s2 * ly;
  }

  function keepInside(sl) {
    var b = bounds(sl, sl.s);
    sl.x = clamp(sl.x, b.x0, b.x1);
    sl.y = clamp(sl.y, b.y0, b.y1);
  }

  // After a gesture: back inside the zoom limits and the photo edges.
  function settle(sl, t, f) {
    if (sl.s < 1) { sl.s = 1; sl.x = 0; sl.y = 0; }
    else if (sl.s > MAX) { zoomAt(sl, MAX, f ? f.x : W / 2, f ? f.y : H / 2); }
    keepInside(sl);
    if (sl.s <= 1.001) { sl.s = 1; sl.x = 0; sl.y = 0; }
    paint(sl, t);
  }

  function base(i) { return (rtl ? 1 : -1) * i * W; }

  function setTrack(x, t) {
    var st = V.track.style;
    st.transition = t ? 'transform ' + t + 'ms ' + EASE : 'none';
    st.transform = 'translate3d(' + x + 'px,0,0)';
  }

  function go(i, t) {
    i = clamp(i, 0, slides.length - 1);
    if (i !== idx) {
      var old = slides[idx];
      if (old && old.s !== 1) { old.s = 1; old.x = 0; old.y = 0; paint(old, t); }
    }
    idx = i;
    setTrack(base(i), t);
    update();
    loadAround(i);
  }

  function update() {
    var n = slides.length;
    V.count.textContent = (idx + 1) + ' ' + T.of + ' ' + n;
    thumbs.forEach(function (b, i) {
      if (i === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    V.prev.disabled = idx === 0;
    V.next.disabled = idx === n - 1;
    V.root.classList.toggle('is-zoomed', slides[idx].s > 1.01);
  }

  // The page shows 1200px photos. The viewer swaps in the 2048px file for
  // the photo on screen and its neighbours, so a zoomed photo stays sharp.
  function loadAround(i) {
    [i, i - 1, i + 1].forEach(function (k) {
      var sl = slides[k];
      if (!sl || sl.hi) return;
      sl.hi = true;
      var src = pics[k].getAttribute('data-zoom-src');
      if (!src) return;
      var tmp = new Image();
      tmp.onload = function () {
        if (tmp.naturalWidth && tmp.naturalHeight) {
          var ar = tmp.naturalWidth / tmp.naturalHeight;
          if (Math.abs(ar - sl.ar) > 0.01) { sl.ar = ar; if (W) fit(sl); }
        }
        sl.img.src = src;
      };
      tmp.src = src;
    });
  }

  function open(i) {
    if (isOpen) return;
    if (!V) build();
    clearTimeout(hideTimer);
    isOpen = true;
    lastFocus = document.activeElement;
    V.root.hidden = false;
    V.root.classList.remove('is-pulling');
    V.bg.style.opacity = '';
    html.classList.add('bkz-lock');
    idx = clamp(i, 0, slides.length - 1);
    measure();
    setTrack(base(idx), 0);
    update();
    loadAround(idx);
    void V.root.offsetWidth;
    V.root.classList.add('is-open');
    try { V.close.focus({ preventScroll: true }); } catch (e) { V.close.focus(); }
    pushed = false;
    if (window.history && history.pushState) {
      try { history.pushState({ bkz: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    }
    window.addEventListener('popstate', onPop);
    window.addEventListener('resize', onResize);
    document.addEventListener('keydown', onKey, true);
  }

  // Close through the browser history when the viewer added an entry, so
  // the back button and the close button end in the same place.
  function requestClose() {
    if (!isOpen) return;
    if (pushed) {
      pushed = false;
      history.back();
      setTimeout(function () { if (isOpen) closeNow(); }, 400);
    } else {
      closeNow();
    }
  }

  function onPop() { if (isOpen) { pushed = false; closeNow(); } }

  function closeNow() {
    if (!isOpen) return;
    isOpen = false;
    window.removeEventListener('popstate', onPop);
    window.removeEventListener('resize', onResize);
    document.removeEventListener('keydown', onKey, true);
    pts = {}; g = null;
    V.root.classList.remove('is-open', 'is-zoomed', 'is-dragging');
    syncPage(idx);
    hideTimer = setTimeout(function () {
      V.root.hidden = true;
      V.root.classList.remove('is-pulling');
      V.bg.style.opacity = '';
      html.classList.remove('bkz-lock');
      slides.forEach(function (sl) {
        sl.box.style.transition = 'none';
        sl.box.style.transform = '';
        sl.s = 1; sl.x = 0; sl.y = 0;
        paint(sl, 0);
      });
    }, ms(200));
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  }

  // Leave the page on the photo the shopper ended on.
  function syncPage(i) {
    var p = pics[i];
    if (!p) return;
    if (wide.matches) {
      if (!p.classList.contains('is-main')) {
        var cur = gallery.querySelector('img.is-main');
        if (cur) cur.classList.remove('is-main');
        p.classList.add('is-main');
      }
      return;
    }
    var pr = p.getBoundingClientRect(), gr = gallery.getBoundingClientRect();
    gallery.scrollLeft += (pr.left + pr.width / 2) - (gr.left + gr.width / 2);
  }

  function onResize() {
    if (!isOpen) return;
    measure();
    setTrack(base(idx), 0);
    update();
  }

  function onKey(e) {
    if (!isOpen) return;
    var k = e.key;
    if (k === 'Escape' || k === 'Esc') { e.preventDefault(); requestClose(); return; }
    if (k === 'ArrowLeft' || k === 'ArrowRight') {
      e.preventDefault();
      var forward = (k === 'ArrowRight') !== rtl;
      go(idx + (forward ? 1 : -1), ms(280));
      return;
    }
    if (k === 'Tab') {
      var f = [].filter.call(V.root.querySelectorAll('button'), function (b) {
        return !b.disabled && b.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (!V.root.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* Gestures in the viewer: pointer events cover fingers and the mouse.
     One finger swipes between photos (or moves a zoomed photo, or pulls
     down to close), two fingers pinch. */
  var pts = {};      // active pointers by id: { x, y } inside the stage
  var g = null;      // the gesture in progress
  var lastTap = null;

  function where(e) {
    var r = V.stage.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  }
  function ids() { return Object.keys(pts); }

  function startPinch(sl) {
    var k = ids(), a = pts[k[0]], b = pts[k[1]];
    var m = mid(a, b);
    g = {
      type: 'pinch', d0: dist(a, b) || 1, s0: sl.s,
      lx: (m.x - sl.l - sl.x) / sl.s, ly: (m.y - sl.t - sl.y) / sl.s, m: m
    };
    V.root.classList.add('is-dragging');
  }

  function startOne(id, sl, mouse, moved) {
    g = {
      type: 'one', id: id, p0: pts[id], t0: Date.now(), x0: sl.x, y0: sl.y,
      moved: !!moved, mode: moved ? (sl.s > 1.01 ? 'pan' : 'none') : null, mouse: mouse
    };
  }

  function onDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (e.target.closest && e.target.closest('.bkz-arrow')) return;
    var id = String(e.pointerId);
    try { V.stage.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
    pts[id] = where(e);
    var sl = slides[idx], n = ids().length;
    if (n === 1) {
      startOne(id, sl, e.pointerType === 'mouse', false);
    } else if (n === 2) {
      if (g && g.mode === 'swipe') setTrack(base(idx), ms(200));
      if (g && g.mode === 'pull') unpull(sl, true);
      startPinch(sl);
    }
    if (e.pointerType === 'mouse') e.preventDefault();
  }

  function onMove(e) {
    var id = String(e.pointerId);
    if (!pts[id]) return;
    pts[id] = where(e);
    if (!g) return;
    var sl = slides[idx];

    if (g.type === 'pinch') {
      var k = ids();
      if (k.length < 2) return;
      var a = pts[k[0]], b = pts[k[1]], m = mid(a, b);
      var s = g.s0 * dist(a, b) / g.d0;
      if (s < 1) s = 1 - (1 - s) * 0.5;
      if (s > MAX) s = MAX + (s - MAX) * 0.3;
      sl.s = Math.max(0.55, s);
      sl.x = m.x - sl.l - sl.s * g.lx;
      sl.y = m.y - sl.t - sl.s * g.ly;
      g.m = m;
      paint(sl, 0);
      return;
    }

    if (id !== g.id) return;
    var p = pts[id], dx = p.x - g.p0.x, dy = p.y - g.p0.y;
    if (!g.moved) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      g.moved = true;
      if (sl.s > 1.01) g.mode = 'pan';
      else if (Math.abs(dx) >= Math.abs(dy)) g.mode = 'swipe';
      else if (!g.mouse && dy > 0) g.mode = 'pull';
      else g.mode = 'none';
      V.root.classList.add('is-dragging');
      if (g.mode === 'pull') V.root.classList.add('is-pulling');
    }

    if (g.mode === 'pan') {
      var bb = bounds(sl, sl.s);
      sl.x = rubber(g.x0 + dx, bb.x0, bb.x1);
      sl.y = rubber(g.y0 + dy, bb.y0, bb.y1);
      paint(sl, 0);
    } else if (g.mode === 'swipe') {
      var forward = rtl ? dx > 0 : dx < 0;
      var edge = (forward && idx === slides.length - 1) || (!forward && idx === 0);
      setTrack(base(idx) + (edge ? dx * 0.3 : dx), 0);
    } else if (g.mode === 'pull') {
      var d = Math.max(0, dy), f = Math.min(1, d / (H * 0.7));
      sl.box.style.transition = 'none';
      sl.box.style.transform = 'translate3d(' + (dx * 0.4) + 'px,' + d + 'px,0) scale(' + (1 - f * 0.25) + ')';
      V.bg.style.transition = 'none';
      V.bg.style.opacity = String(1 - f);
    }
  }

  function unpull(sl, animate) {
    var t = animate ? ms(220) : 0;
    sl.box.style.transition = t ? 'transform ' + t + 'ms ' + EASE : 'none';
    sl.box.style.transform = '';
    V.bg.style.transition = t ? 'opacity ' + t + 'ms ease' : 'none';
    V.bg.style.opacity = '';
    V.root.classList.remove('is-pulling');
  }

  function onUp(e) {
    var id = String(e.pointerId);
    var p = pts[id];
    if (!p) return;
    delete pts[id];
    if (!g) return;
    var sl = slides[idx], left = ids();

    if (g.type === 'pinch') {
      if (left.length === 1) {
        // One finger stays down: carry on moving the photo with it.
        if (sl.s < 1) settle(sl, ms(220));
        startOne(left[0], sl, false, true);
        return;
      }
      if (left.length === 0) {
        g = null;
        V.root.classList.remove('is-dragging');
        settle(sl, ms(220), null);
      }
      return;
    }

    if (id !== g.id) return;
    var dt = Math.max(1, Date.now() - g.t0), dx = p.x - g.p0.x, dy = p.y - g.p0.y;
    var gest = g;
    g = null;
    V.root.classList.remove('is-dragging');

    if (!gest.moved) {
      if (e.type === 'pointerup') tap(p, gest.mouse);
      return;
    }
    if (gest.mode === 'pan') {
      settle(sl, ms(220));
    } else if (gest.mode === 'swipe') {
      var forward = rtl ? dx > 0 : dx < 0;
      var fast = Math.abs(dx) / dt > 0.45 && Math.abs(dx) > 20;
      if (Math.abs(dx) > W * 0.18 || fast) go(idx + (forward ? 1 : -1), ms(280));
      else go(idx, ms(240));
    } else if (gest.mode === 'pull') {
      if (dy > 110 || (dy / dt > 0.6 && dy > 30)) requestClose();
      else unpull(sl, true);
    }
  }

  function inPhoto(sl, p) {
    var x0 = sl.l + sl.x, y0 = sl.t + sl.y;
    return p.x >= x0 && p.x <= x0 + sl.fw * sl.s && p.y >= y0 && p.y <= y0 + sl.fh * sl.s;
  }

  function toggleZoom(sl, p) {
    if (sl.s > 1.01) {
      sl.s = 1; sl.x = 0; sl.y = 0;
    } else {
      zoomAt(sl, STEP, p.x, p.y);
      keepInside(sl);
    }
    paint(sl, ms(260));
  }

  // A click zooms on computers; a double-tap zooms on phones.
  function tap(p, mouse) {
    var sl = slides[idx], now = Date.now();
    if (mouse) {
      if (sl.s > 1.01 || inPhoto(sl, p)) toggleZoom(sl, p);
      return;
    }
    if (lastTap && now - lastTap.t < 320 && dist(lastTap.p, p) < 40) {
      lastTap = null;
      toggleZoom(sl, p);
      return;
    }
    lastTap = { t: now, p: p };
  }

  function onWheel(e) {
    e.preventDefault();
    if (!isOpen) return;
    var sl = slides[idx], p = where(e);
    var dy = e.deltaY * (e.deltaMode === 1 ? 16 : 1);
    var s2 = clamp(sl.s * Math.exp(-dy * (e.ctrlKey ? 0.01 : 0.002)), 1, MAX);
    zoomAt(sl, s2, p.x, p.y);
    keepInside(sl);
    if (sl.s <= 1.001) { sl.s = 1; sl.x = 0; sl.y = 0; }
    paint(sl, 0);
  }

  /* Opening from the page. A capture listener runs before the small
     gallery script, so a click on a small photo (tablets and computers)
     is left to that script and only the large photo opens the viewer. */
  gallery.addEventListener('click', function (e) {
    var im = e.target && e.target.closest ? e.target.closest('img') : null;
    var i = pics.indexOf(im);
    if (i < 0) return;
    if (wide.matches && !im.classList.contains('is-main')) return;
    open(i);
  }, true);

  gallery.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (pics.indexOf(e.target) < 0) return;
    e.preventDefault();
    e.target.click();
  });

  /* ------------------------------------------------------------------
     2. Pinch in place on the swipe strip (phones). Touch events, because
     one finger must keep scrolling the strip and the page natively.
     ------------------------------------------------------------------ */
  var pz = null;

  function tp(t) { return { x: t.clientX, y: t.clientY }; }

  function pinchStart(e) {
    if (pz || isOpen || wide.matches || e.touches.length !== 2) return;
    var a = e.touches[0], b = e.touches[1], im = null;
    if (a.target && a.target.closest) im = a.target.closest('.pdp-gallery img');
    if (!im && b.target && b.target.closest) im = b.target.closest('.pdp-gallery img');
    if (pics.indexOf(im) < 0) return;
    if (e.cancelable) e.preventDefault();

    var r = im.getBoundingClientRect(), cs = window.getComputedStyle(im);
    var ov = make('div', 'bkz-pinch');
    var bg = make('div', 'bkz-pinch__bg');
    var cl = make('img', 'bkz-pinch__img', { alt: '' });
    cl.src = srcOf(im);
    cl.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height +
      'px;border-radius:' + cs.borderRadius + ';object-fit:' + cs.objectFit + ';';
    ov.appendChild(bg);
    ov.appendChild(cl);
    document.body.appendChild(ov);
    im.style.visibility = 'hidden';

    var pa = tp(a), pb = tp(b), m0 = mid(pa, pb);
    pz = { im: im, ov: ov, bg: bg, cl: cl, r: r, d0: dist(pa, pb) || 1, lx: m0.x - r.left, ly: m0.y - r.top };
    document.addEventListener('touchmove', pinchMove, { passive: false });
    document.addEventListener('touchend', pinchEnd);
    document.addEventListener('touchcancel', pinchEnd);
  }

  function pinchMove(e) {
    if (!pz) return;
    if (e.cancelable) e.preventDefault();
    if (e.touches.length < 2) return;
    var pa = tp(e.touches[0]), pb = tp(e.touches[1]), m = mid(pa, pb);
    var s = clamp(dist(pa, pb) / pz.d0, 1, 4);
    var x = m.x - pz.r.left - s * pz.lx, y = m.y - pz.r.top - s * pz.ly;
    pz.cl.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + s + ')';
    pz.bg.style.opacity = String(Math.min(0.72, (s - 1) * 0.9));
  }

  function pinchEnd(e) {
    if (!pz || (e && e.touches && e.touches.length >= 2)) return;
    var z = pz;
    pz = null;
    document.removeEventListener('touchmove', pinchMove, { passive: false });
    document.removeEventListener('touchend', pinchEnd);
    document.removeEventListener('touchcancel', pinchEnd);
    var t = ms(260);
    z.cl.style.transition = t ? 'transform ' + t + 'ms ' + EASE : 'none';
    z.bg.style.transition = t ? 'opacity ' + t + 'ms ease' : 'none';
    z.cl.style.transform = 'translate3d(0,0,0) scale(1)';
    z.bg.style.opacity = '0';
    setTimeout(function () {
      z.im.style.visibility = '';
      if (z.ov.parentNode) z.ov.parentNode.removeChild(z.ov);
    }, t + 20);
  }

  gallery.addEventListener('touchstart', pinchStart, { passive: false });
  // Older iPhones: keep Safari's own page zoom off the strip while pinching.
  gallery.addEventListener('gesturestart', function (e) { if (!wide.matches) e.preventDefault(); });
})();
